<template>
    <div>
        <div class="modal right" tabindex="-1" role="dialog" id="ParentFieldExpressionModel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Add Value to Parent Field')}}</h6>
                        <button
                            class="close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            v-on:click="closeDialog()"
                            title="Close"
                            >
                            <span aria-hidden="true">
                                <cancel-icon tabindex="0" class="close-icon categorybrowse" style="height: 30px !important;
                                    width: 30px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body" ref="mappersList">
                        <div class="value-style d-inline-flex bg-transparent rounded text-light" style="width:100%;">
                            <div style="width: 15%;padding-top: 14px;text-align: end;padding-inline-end: 8px;word-break: break-all;">
                                {{$t('Load when')}}
                            </div>
                            <div style="display:inline-flex;width:100%">
                                <table class="table-scroll" style="background: transparent; width: 100%">
                                    <thead>
                                        <tr>
                                            <th scope="col" style="width: 35%" class="text-left col-md-3"></th>
                                            <th scope="col" style="width: 65%" class="text-center col-md-6"></th>
                                        </tr>
                                    </thead>
                                    <tbody class="body-half-screen">
                                        <tr>
                                            <td style="vertical-align: top">
                                                <Multiselect
                                                    :value="parentField" 
                                                    :options="parentFieldOptionsList"
                                                    label="name"
                                                    track-by="_id"
                                                    :close-on-select="true"
                                                    :multiple=false
                                                    :show-no-results="true"
                                                    deselectLabel =""
                                                    selectLabel=""
                                                    selectedLabel=""
                                                    :placeholder="$t('Enter field name')"
                                                    :hideSelected="false"
                                                    :showNoOptions="false"
                                                    @select="parentFielOnSelect($event)"
                                                    >
                                                    <span slot="noResult">No results.</span>
                                                </Multiselect>
                                            </td>
                                            <td>
                                                <div>
                                                    <div v-if="parentField.type =='FREETEXT'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                        <span class="key-style"> {{$t('contains')}}</span>
                                                        <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode"> <!-- && !newProfile && isNewRow != key.uuid-->
                                                            <span v-if="parentField.value != undefined && parentField.value.length == 0"  class="empty-field-text-styles">NONE</span>
                                                            <span v-else>{{parentField.value}}</span>
                                                            <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                        </div>
                                                        <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper"> <!-- || newProfile || isNewRow == key.uuid-->
                                                            <input
                                                                    type="text"
                                                                    id="field_value"
                                                                    class="rounded text-light comm-input-field-style"
                                                                    v-model="parentField.value"
                                                                    autocomplete="off"
                                                                    placeholder="ex: Olympics"
                                                                    style="height: 42px;position: relative;width:90%"
                                                            />
                                                            <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;"> <!-- || isNewRow == key.uuid) && !newProfile"-->  
                                                                <save-icon v-on:click.native="saveEditedField(parentField.value,parentField.uuid)"></save-icon>
                                                                <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="parentField.type == 'FREETEXT_MULTILINE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <span class="key-style"> {{$t('contains')}}</span>
                                                    <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode">
                                                        <span v-if="parentField.value.length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start;line-height:normal">{{parentField.value}}</span>
                                                        <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                    </div>
                                                    <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">
                                                        <textarea
                                                                id="field_value"
                                                                class="rounded text-light comm-input-field-style"
                                                                v-model="parentField.value"
                                                                autocomplete="off"
                                                                placeholder="ex: Olympics"
                                                                style="height: 100px;position: relative;margin-bottom:5px;"
                                                        ></textarea>
                                                        <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;">
                                                            <save-icon v-on:click.native="saveEditedField(parentField.value,parentField.uuid)"></save-icon>
                                                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div v-if="parentField.type == 'DATE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <span class="key-style"> {{$t('between')}}</span>
                                                    <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode">
                                                        <span v-if="Object.keys(parentField.value).length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start">{{parentField.value[0] + ' ~ ' + parentField.value[1]}}</span>
                                                        <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                    </div>
                                                    <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">
                                                        <date-picker
                                                                range
                                                                v-model="selectedTime"
                                                                valueType="format"
                                                                placeholder="ex: yyyy-mm-dd ~ yyyy-mm-dd"
                                                                class="text-light comm-input-field-style"
                                                                style="padding: 0px;border-radius: 5px;position:relative;top:6px"
                                                                :id="parentField.uuid"
                                                                @change="parentField.value = selectedTime"
                                                        ></date-picker>
                                                        <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;"> <!-- && !newProfile"-->
                                                            <save-icon v-on:click.native="saveEditedField(selectedTime,parentField.uuid)"></save-icon>
                                                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div v-if="parentField.type == 'DATE_TIME'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <span class="key-style"> {{$t('between')}}</span>
                                                    <div v-if="!isEditing(parentField.uuid) &&!newField" class="fields-on-non-edit-mode">
                                                        <span v-if="Object.keys(parentField.value).length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start">{{parentField.value[0] + ' ~ ' + parentField.value[1]}}</span>
                                                        <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                    </div>
                                                    <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">
                                                        <date-picker
                                                                range
                                                                v-model="selectedDateTime"
                                                                placeholder="ex: yyyy-mm-dd hh:mm:ss ~ yyyy-mm-dd hh:mm:ss"
                                                                class="text-light comm-input-field-style"
                                                                style="padding: 0px;border-radius: 5px;position:relative;top:6px;width: 100%;"
                                                                :id="parentField.uuid"
                                                                type="datetime"
                                                                valueType="format"
                                                                @change="parentField.value = selectedDateTime"
                                                                confirm
                                                        ></date-picker>
                                                        <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;">
                                                            <save-icon v-on:click.native="saveEditedField(selectedDateTime,parentField.uuid)"></save-icon>
                                                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div v-if="parentField.type == 'INTEGER'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <span class="key-style" style="width:31%"> {{$t('from')}}</span>
                                                    <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode">
                                                        <span v-if="key.value == undefined || (key.value != undefined && key.value.length == 0)"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else>{{key.value['from'] + "  to  " + key.value['to']}}</span>
                                                        <edit-icon v-on:click.native="editingKey = key.uuid" class="editIconClass"></edit-icon>
                                                    </div>
                                                    <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">
                                                    <input
                                                                type="number"
                                                                id="date_value"
                                                                style="width:35%;position:relative;top:6px"
                                                                class="rounded text-light comm-input-field-style"
                                                                placeholder="ex: 0"
                                                                v-model="parentField.value['from']"
                                                                autocomplete="off"
                                                    />
                                                    <span class="key-style"> to</span>
                                                    <input
                                                                type="number"
                                                                id="date_value"
                                                                style="width:35%;position:relative;top:6px"
                                                                class="rounded text-light comm-input-field-style"
                                                                placeholder="ex: 10"
                                                                v-model="parentField.value['to']"
                                                                autocomplete="off"
                                                    />
                                                    <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;"> <!--&& !newProfile-->
                                                        <save-icon v-on:click.native="saveEditedField(parentField.value,parentField.uuid)"></save-icon>
                                                        <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                    </div>
                                                    </div>
                                                    </div>
                                                    <div v-if="['PICKLIST'].includes(parentField.type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                        <span class="key-style"> contains</span>
                                                        <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                            <span v-if="selectedPickListNameValues[parentField.name] != undefined && selectedPickListNameValues[parentField.name].length == 0"  class="empty-field-text-styles">NONE</span>
                                                            <div v-else v-for="picklist in selectedPickListNameValues[parentField.name]" :key="picklist._id" class="tags-style">
                                                            <div class="user-name-display user-name-display-as-tags">{{picklist.name}}</div>
                                                            </div>
                                                            <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                        </div>
                                                        <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">
                                                            <Multiselect
                                                            :value="selectedPickListNameValues[parentField.name]"
                                                            :options="getPikListValues(parentField.name)"
                                                            :multiple="false"
                                                            track-by="_id"
                                                            label="label"
                                                            :close-on-select="true"
                                                            :show-no-results="false"
                                                            deselectLabel =""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            :placeholder="$t('Enter picklist name')"
                                                            :hideSelected="false"
                                                            :showNoOptions="false"
                                                            @select="picklistValueTypeOnSelect($event, parentField.name, parentField.uuid)">
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                            <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                            </div>
                                                            <span slot="noResult">No results</span>
                                                            <span slot="noOptions" style="display:none"></span>
                                                            </Multiselect>
                                                            <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;"> <!-- && !newProfile"-->
                                                                <save-icon v-on:click.native="saveEditedField(selectedPickListNameValues[parentField.name],parentField.uuid)"></save-icon>
                                                                <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="['PICKLIST_MULTIVALUE'].includes(parentField.type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <span class="key-style"> contains</span>
                                                    <div v-if="!isEditing(parentField.uuid) && !newField" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                        <span v-if="selectedMultiPickListNameValues[parentField.name] != undefined && selectedMultiPickListNameValues[parentField.name].length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <div v-else v-for="picklist in selectedMultiPickListNameValues[parentField.name]" :key="picklist._id" class="tags-style">
                                                        <div class="user-name-display user-name-display-as-tags">{{picklist.name}}</div>
                                                        </div>
                                                        <edit-icon v-on:click.native="editingKey = parentField.uuid" class="editIconClass"></edit-icon>
                                                    </div>
                                                    <div v-else-if="isEditing(parentField.uuid) || newField" class="input-field-wrapper">  
                                                        <Multiselect
                                                        v-model="selectedMultiPickListNameValues[parentField.name]" 
                                                        :options="getMultiPikListValues(parentField.name)"
                                                        :multiple="true"
                                                        track-by="_id"
                                                        label="label"
                                                        :close-on-select="false"
                                                        :show-no-results="false"
                                                        deselectLabel =""
                                                        selectLabel=""
                                                        selectedLabel=""
                                                        :placeholder="$t('Enter picklist name')"
                                                        :hideSelected="false"
                                                        :showNoOptions="false">
                                                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                        <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeMultiPickValCheckBoxSelection(scope.option,parentField.name)" @focus.prevent :key="scope.option.label"/>
                                                        <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                        </div>
                                                        <span slot="noResult">No results</span>
                                                        <span slot="noOptions" style="display:none"></span>
                                                        </Multiselect>
                                                        <div v-if="(isEditing(parentField.uuid))" style="display: inline-flex;align-items: center;">
                                                            <save-icon v-on:click.native="saveEditedField(selectedMultiPickListNameValues[parentField.name],parentField.uuid)"></save-icon>
                                                            <cancel-icon v-on:click.native="cancelEditMode()" style="inset-inline-end:-50px"></cancel-icon>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            
                                            </td>
                                        </tr>    
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <button class="btn btn-outline-secondary ml-1" title="Close" @click="closeDialog()">Cancel</button>
                        <button v-if="newField" class="btn btn-outline-primary ml-1" title="Save Expression" @click="saveParentFieldExpressionDictMapper()">Save</button>
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import Multiselect from 'vue-multiselect';
import {mapActions, mapGetters} from "vuex"
import editIcon from "../core/InlineEditField.vue";
import saveIcon from "../core/InlineSaveField.vue";
// import deleteIcon from "../core/InlineDeleteIcon.vue";
import DatePicker from "vue2-datepicker";
import Utils from "../../components.utils.js";
export default {
    props:["selectedParentField", "parentFieldOptionsList", "isExpressionEditContext", "newField", 'beforeAddedValues'],
    data(){
        return{
            parentField:{},
            parentFieldOptions:[],

            pickListNameValues:{},
            selectedPickListNameValues:{},
            selectedMultiPickListNameValues:{},
            loadUuidPickValues:{},
            startupFieldsList:[],
            loadTypes:[],
            editingKey:null,
            selectedDateTime:"",
            selectedTime:"",

        }
    }, 
    
    watch:{
        "parentFieldOptionsList" : function(newVal, oldVal){
            if(newVal != oldVal){
                this.parentFieldOptions =  this.parentFieldOptionsList;
            }
        }    
    },
    components:{
        "cancel-icon": CancelIcon,
        "edit-icon":editIcon,
        "save-icon":saveIcon,
        // "delete-icon":deleteIcon,
        "date-picker":DatePicker,
        Multiselect,
    },
    methods:{
        closeDialog(){
            this.$emit("closeFeildExpressionModel", true);
        },
        showAlert(){
            alert("LLL");
            return false;
        },

        getFieldsFromServer(){
            let payload = {}
            this.getAllCustomMetadataFromServer(payload).then((data)=>{
                let fieldList = [];
                fieldList = fieldList.concat(data.custom_metadatas)
                for(let eachField of fieldList){
                eachField['name'] = this.getCustomMetadataName(eachField)
                }
                this.parentFieldOptions = fieldList;
            }); 
        },

        parentFielOnSelect(option){
            console.log("value....", option);
            if(option.type == "DATE" || option.type == "DATE_TIME"){
                alert("'Add Value to Parent Field' is not supported with 'DATE' type Field");
                return false;
            }
            this.parentField = option;
            if(option == 'INTEGER'){
                this.parentField.value={
                      'from':0,
                      'to':1
                    }
            }
            
            if(option){
                let tempMultiValList = [];
                let tempValList = [];
                // for(let fDetails of this.startupFieldsList){
                let fDetails = option;
                    let fieldName = this.getCustomMetadataName(fDetails)
                    if(['PICKLIST_MULTIVALUE'].includes(fDetails.type)){
                        for(let pickVal of fDetails.values){
                            tempMultiValList.push({
                            "_id":pickVal.value_id,
                            "label":pickVal.value,
                            "PLabel":fieldName,
                            "type":fDetails.type,
                            })
                        }
                    }else if(['PICKLIST'].includes(fDetails.type)){
                        for(let pickVal of fDetails.values){
                            tempValList.push({
                            "_id":pickVal.value_id,
                            "label":pickVal.value,
                            "PLabel":fieldName,
                            "type":fDetails.type,
                            })
                        }
                    }
                    this.loadTypes.push({
                        "label":fieldName,
                        "type":fDetails.type,
                        "key_id":fDetails._id
                    })
                // }
                this.multiPickListNameValues = tempMultiValList;
                this.pickListNameValues = tempValList;
            }

            this.$emit("selectedParentElement", option);
            
            // this.pickListNameValues = option.values;

        },  

        style(name){
          let style = {
          'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
          'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
          }
          return style
        },
        isEditing(keyUuid) {
            return keyUuid === this.editingKey;
        },

        getPikListValues(FLabel){
          return this.pickListNameValues.filter(item=>item.PLabel == FLabel);
        },
        getMultiPikListValues(FLabel){
          return this.multiPickListNameValues.filter(item=>item.PLabel == FLabel);
        },
        picklistValueTypeOnSelect(option,FLabel,FUuid){
            let index = this.pickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
            
            if(index > -1){
                this.pickListNameValues[index].checked = true;
                this.$set(this.selectedPickListNameValues, FLabel, option)
                let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid);
                if(findType != undefined && findType.length){
                findType[0].value = [option._id];
                this.updateLoadType("load_when");
                }
            }
        },
        multiPicklistValueTypeOnSelect(option,FLabel,FUuid){
          let index = this.multiPickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
          if(index > -1){
            this.multiPickListNameValues[index].checked = true;
            let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && !loadU.value.includes(option.label));
            if(findType != undefined && findType.length){
              findType[0].value.push(option._id);
            }
          }
        },
        multiPicklistValueTypeOnRemove(option,FLabel,FUuid){
          let index = this.multiPickListNameValues.findIndex(item => item._id == option._id && item.PLabel == FLabel);
          if(index > -1){
              this.multiPickListNameValues[index].checked = false;
              let findType = this.loadValueType.filter(loadU=>loadU.uuid == FUuid && loadU.value.includes(option._id));
              if(findType != undefined && findType.length){
                findType[0].value.splice(findType[0].value.indexOf(option._id),1);
              }
          }
         },
        makeMultiPickValCheckBoxSelection(option,FLabel){
          if(Object.keys(this.selectedMultiPickListNameValues).includes(FLabel)){
            return this.selectedMultiPickListNameValues[FLabel].some((op) => op._id === option._id);
          }else{
            return false;
          }
        },
        // picklistTypeValueCallback(option){
        //   return `${option.label}`
        // },
        //
        //field id's Operations
        // getLoadWhenFieldIds(){
        //   for(let loadF of this.loadValueType){
        //     if(loadF.uuid == this.fieldBrowser.uuid){
        //       return loadF.id_list;
        //     }
        //   }
        //   return [];
        // },
        // getFieldNamefromId(fieldId){
        //   if(Object.keys(this.selectedFieldIdNameMap).includes(fieldId)){
        //     return this.selectedFieldIdNameMap[fieldId];
        //   }
        //   return "None";
        // },
        // deleteFieldIdFromList(fieldId, loadFUuid){
        //   for(let loadF of this.loadValueType){
        //     if(loadF.uuid == loadFUuid){
        //         let findIndex = loadF.id_list.findIndex(t=>t.id==fieldId);
        //         loadF.id_list.splice(findIndex,1);
        //         break;
        //     }
        //   }
        //   this.updateLoadType("load_when");
        // },

        getCustomMetadataName(fieldInfo){
            if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
              let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
              if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
                return mapperExists.field_alias;
              }
            }
            return fieldInfo.name;
        },

        saveParentFieldExpressionDictMapper(){
            let parentFieldValue = "";
            if(this.parentField.type == "PICKLIST"){
                parentFieldValue = this.selectedPickListNameValues[this.parentField.name];
            }else if(this.parentField.type == "PICKLIST_MULTIVALUE"){
                parentFieldValue = this.selectedMultiPickListNameValues[this.parentField.name];   
            }else if(this.parentField.type == 'FREETEXT' || this.parentField.type == 'INTEGER' || this.parentField.type == 'FREETEXT_MULTILINE'){
                let parentFieldObj = {};
                parentFieldObj["PLabel"] = this.parentField.name;
                parentFieldObj["_id"] = this.parentField._id;
                parentFieldObj["value"] = this.parentField.value;
                parentFieldObj["type"] = this.parentField.type;
                parentFieldValue = parentFieldObj;
            }
            // else if(this.parentField.type == "DATE_TIME"){
            //     let parentFieldObj = {};
            //     parentFieldObj["PLabel"] = this.parentField.name;
            //     parentFieldObj["_id"] = this.parentField._id;
            //     parentFieldObj["value"] = this.selectedDateTime;
            //     parentFieldObj["type"] = this.parentField.type;
            //     parentFieldValue = parentFieldObj;
                
            // }else if(this.parentField.type == "DATE"){
            //     let parentFieldObj = {};
            //     parentFieldObj["PLabel"] = this.parentField.name;
            //     parentFieldObj["_id"] = this.parentField._id;
            //     parentFieldObj["value"] = this.selectedTime;
            //     parentFieldObj["type"] = this.parentField.type;
            //     parentFieldValue = parentFieldObj;
                
            // }
            
            if(!parentFieldValue){
                alert("Please Add Value");
                return false;
            }
            this.$emit("addedExpressionDict", parentFieldValue);
            this.closeDialog();
        },

        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapActions("customMetadata",["addNewCustomMetadata", "getAllCustomMetadataFromServer"]),

    },
    created(){
        this.parentFieldOptions = this.parentFieldOptionsList;
        this.parentField = this.selectedParentField;
        if(Array.isArray(this.beforeAddedValues)){
            this.$set(this.selectedMultiPickListNameValues, this.beforeAddedValues[0].PLabel, this.beforeAddedValues)
        }else if(this.beforeAddedValues.type == "PICKLIST"){  
            // let keyName = 'PLabel' in this.beforeAddedValues ? this.beforeAddedValues.PLabel : this.beforeAddedValues.name;
            // let valueObj = 'PLabel' in this.beforeAddedValues ? this.beforeAddedValues : this.beforeAddedValues.value_info[0];
            this.$set(this.selectedPickListNameValues, this.beforeAddedValues.PLabel, this.beforeAddedValues)
        }
        // this.beforeAddedValues = this.beforeAddedValues;
        // if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
        //     this.startupFieldsList = this.getStartUpDataFromInCache()["custom_metadatas"];
            // if(this.startupFieldsList != undefined){
            if(this.selectedParentField){
                let tempMultiValList = [];
                let tempValList = [];
                // for(let fDetails of this.startupFieldsList){
                let fDetails = this.selectedParentField;
                    let fieldName = this.getCustomMetadataName(fDetails)
                    if(['PICKLIST_MULTIVALUE'].includes(fDetails.type)){
                        for(let pickVal of fDetails.values){
                            tempMultiValList.push({
                            "_id":pickVal.value_id,
                            "label":pickVal.value,
                            "PLabel":fieldName,
                            "type":fDetails.type,
                            })
                        }
                    }else if(['PICKLIST'].includes(fDetails.type)){
                        for(let pickVal of fDetails.values){
                            tempValList.push({
                            "_id":pickVal.value_id,
                            "label":pickVal.value,
                            "PLabel":fieldName,
                            "type":fDetails.type,
                            })
                        }
                    }
                    this.loadTypes.push({
                        "label":fieldName,
                        "type":fDetails.type,
                        "key_id":fDetails._id
                    })
                // }
                this.multiPickListNameValues = tempMultiValList;
                this.pickListNameValues = tempValList;
            }
        // }

    }   
}    

</script>
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $border-on-hover: 1px solid #61707d;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $icon-hover:#2c3339;
  
    .modal-dialog {
        max-width: 810px;
        width: 810px;
        max-height: 100%;
        margin: 0;
        padding: 0;
    }

    .modal{
        transition: opacity .3s ease;
    }

    .modal-content {
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            // overflow: auto;
            background: #1a1e21;
            padding: 1rem;
            padding-inline-end: 0.4rem !important;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        
    }
    .modal-header .close {
        // margin: -1rem -13px -1rem auto !important;
        margin:0px !important;
        padding: 0px !important;
    }
    .modal:before {
        content: '';
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }

    .btn{
        font-size:$input-field-and-label-font-size !important;
        height:100%;
    }

    .border{
        border: $border-color !important;
    }

    .modal-header{
        align-items: center
    }

    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        height: 58px;
        .modal-title{
            color:$text-color;
        }
    }

    .primary-btn-style{
        padding: 8px 16px !important;
        button{
            height: 35px;
            width: 75px;
            font-size:$input-field-and-label-font-size;
        }
    }

    .secondary-btn-style{
        color:$text-color;
    }

    .key-style {
        color: $dull-text-color;
        width: 16%;
        font-size: $input-field-and-label-font-size;
        // margin-top: 11px;
    }

    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }

    .empty-field-text-styles{
        color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        // svg{
        //     position: absolute;
        //     inset-inline-end :-27px;
        //     top: 12px;
        //     height:25px;
        // }
    }

    .fields-on-non-edit-mode{
        width:70%;
        // display:inline-flex;
        line-height:46px;
        text-align: start;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }
  
    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }
  
    .tags-display-ul{
        list-style-type: none;
    }
    
    .tags-display-ul .show-tags-delete{
        visibility:hidden;
    }
    
    .searched-metadata-display-fields{
        height: auto;
        // overflow: auto;
        width: 100%;
    }
    
    .view-tags:hover .show-tags-delete{
        visibility: visible;
    }
    
    .view-tags:hover {
        border: $border-on-hover !important;
    }
  
    .key-style {
        color: $dull-text-color;
        width: 34%;
        text-align: center;
        font-size: $input-field-and-label-font-size;
        padding-inline-start: 5px;
        padding-inline-end: 5px;
        margin-top: 13px;
    }
    
    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
        }
    }
  
    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 14px;
            line-height: 32px;
            color: $secondary-text-color;
            text-align:end;
        }
    }
  
    .comm-input-field-style{
        background: $primary-background!important;
        width: 100%;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: 42px;
    }

    .comm-tags-field-wrapper-style{
        background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }
  
    ::v-deep{
        .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
            background: $primary-background;
            border-bottom: $border-color;
        }
        .mx-input{
            background-color: $primary-background  !important;
            border: none !important;
            color: $text-color !important;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:auto;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-icon-calendar{
            color:$text-color;
        }
    }
  
    .name-style{
        width: 100%;
        text-align: start;
        padding-top: 0px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
        .slug-ellipsis{
            white-space: nowrap;
            max-width: 350px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        max-height: 345px;
        overflow: auto;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }
  
    .input-fields:focus{
        outline: unset;
        border-bottom: 1px solid #0373ee !important;
    }
    
    .focusField{
        input:focus, select:focus{
          border:none !important;
        }
    }
    
    .tags-wrapper{
        position: absolute;
        inset-inline-end: 0px;
    }
    svg {
        color: #666666;
    }
    
    svg:hover {
        color: $text-color;
    }
  
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        width: 100%;
        thead {
            color: $dull-text-color !important;
            position: relative;
            th{
                position: sticky;
                top: 0;
                background: $primary-background;
                z-index:9;
                text-align: start;
                padding:0px;
                border:none;
            }
        }
        tbody {
            width: 100%;
            // overflow: auto;
            font-weight: 500;
            tr{
                height:40px;
                border-bottom: 1px solid $primary-background;
                padding:0px;
            }
        }
    }
  
    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        // inset-inline-start :18px;
    }
    
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
  
    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
  
    .height-set-for-component {
        height: calc(100% - 120px);
    }
  
    ::v-deep{
        .multiselect{
            width:240px !important;
            margin: 3px 0px;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__placeholder {
            padding-top: 0px;
            margin-bottom:0px;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px; 
            height: auto !important;
            width:90% !important;
        }
        .multiselect__single{
            padding-top:3px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute !important;
            display: block;
            background: $text-color;
            width: 100% !important;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto !important;
            min-height: 38px;
        }
    }
  
    // .browse-icon{
    //     position: relative;
    //     inset-inline-start :8px;
    //     top: 8px;
    // }
    
    .table td, .table th {
        border-top: none;
        padding:0px;
    }
  
    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }
    
    .select-catalog-field{
        width: 101%;
        .name-style{
            width:100%;
        }
    }
  
    .editIconClass{
        visibility: hidden;
    }
    
    .comm-screen-profile-fields:hover{
        .editIconClass{
            visibility: visible;
            margin-inline-start: 8px;
        }
    }
  
    .user-name-or-image-in-selected-option{
        border: $border-color;
        height: 27px;
        width: 27px;
        border-radius: 5px;
        text-align: center;
        line-height: 26px;
        text-transform: uppercase;
        margin-top: -1px;
        margin-inline-start: -1px;
    }
  
    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
        .user-name-display-as-tags{
            line-height: 27px;
            margin: 0px 5px;
            width:auto;
        }
    }
    .add-screens-styles{
        display: inline-flex;
        height: 45px;
        border: 1px solid $add-button-border-color;
        border-radius: 10px;
        width: 240px;
        margin-block: 8px;
        margin-inline-start: 0;
        margin-inline-end: 10px;
        color: $add-button-text-color;
        font-size: 15px;
        align-items: center;
        justify-content: center;
        svg{
            margin-inline-end: 7px;
            color:$add-button-text-color !important;
        }
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
        svg{
            color:$add-button-text-color-hover !important;
        }
    }
</style>